import { Routes, Route } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";

import SignInPage from "./pages/SignInPage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";

import BlogPage from "./pages/BlogPage";
import BlogCategory from "./pages/BlogCategory";
import BlogTags from "./pages/BlogTags";
import CreateBlogPage from "./pages/CreateBlog/CreateBlogPage";
import EditBlogPage from "./pages/EditBlog/EditBlogPage";

import ProductCategory from "./pages/ProductCategory/productCategory";
import CreateProduct from "./pages/CreateProduct/CreateProduct";
import PublishedProducts from "./pages/PublishedProducts/PublishedProducts";

import SliderManagement from "./pages/SliderManagement/SliderManagement";
import ContactInquiry from "./pages/ContactInquiry";
import ProductInquiry from "./pages/ProductInquiry/ProductInquiry";

import ProtectedRoute from "./authRoute/ProtectedRoute";
import PublicRoute from "./authRoute/PublicRoute";

function App() {
  return (
    <>
      <RouteScrollToTop />

      <Routes>

        {/* PUBLIC */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <SignInPage />
            </PublicRoute>
          }
        />

        {/* DASHBOARD (ADMIN + AUTHOR) */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute roles={["ADMIN", "AUTHOR"]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        {/* BLOG MODULE (ADMIN + AUTHOR) */}

        <Route
          path="/blog"
          element={
            <ProtectedRoute roles={["ADMIN", "AUTHOR"]}>
              <BlogPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/blog-category"
          element={
            <ProtectedRoute roles={["ADMIN", "AUTHOR"]}>
              <BlogCategory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/blog-tags"
          element={
            <ProtectedRoute roles={["ADMIN", "AUTHOR"]}>
              <BlogTags />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-blog"
          element={
            <ProtectedRoute roles={["ADMIN", "AUTHOR"]}>
              <CreateBlogPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-blog"
          element={
            <ProtectedRoute roles={["ADMIN", "AUTHOR"]}>
              <EditBlogPage />
            </ProtectedRoute>
          }
        />

        {/* PRODUCT MODULE (ADMIN ONLY) */}

        <Route
          path="/product-category"
          element={
            <ProtectedRoute roles={["ADMIN"]}>
              <ProductCategory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-product"
          element={
            <ProtectedRoute roles={["ADMIN"]}>
              <CreateProduct />
            </ProtectedRoute>
          }
        />

        <Route
          path="/published-products"
          element={
            <ProtectedRoute roles={["ADMIN"]}>
              <PublishedProducts />
            </ProtectedRoute>
          }
        />

        {/* SLIDER (ADMIN ONLY) */}

        <Route
          path="/slider-management"
          element={
            <ProtectedRoute roles={["ADMIN"]}>
              <SliderManagement />
            </ProtectedRoute>
          }
        />

        {/* INQUIRY (ADMIN ONLY) */}

        <Route
          path="/contact-inquiry"
          element={
            <ProtectedRoute roles={["ADMIN"]}>
              <ContactInquiry />
            </ProtectedRoute>
          }
        />

        <Route
          path="/product-inquiry"
          element={
            <ProtectedRoute roles={["ADMIN"]}>
              <ProductInquiry />
            </ProtectedRoute>
          }
        />

        {/* ACCESS DENIED */}
        <Route path="/access-denied" element={<AccessDeniedPage />} />

      </Routes>
    </>
  );
}

export default App;